import {React,useContext} from 'react';
import  gPay  from '../images/gpay.jpeg'
import LinkedInIcon from '../images/icon_linkedin.png'; // Make sure to have the LinkedIn icon image in the correct path
import { Link } from 'react-router-dom';
import { AuthContext } from '../authmanager/authcontext';
import { CartContext } from '../cart/cart';
import Navbar from '../navbar/navbar';
const About = ({toggleTheme}) => {
  const { isLoggedIn, handleLogout } = useContext(AuthContext);
  const {
    cartItems,
    addToCart,
    removeProductByQuantityFromCart,
    finalizeCart,
  } = useContext(CartContext);
  const styles = {
    section: {
      padding: '20px',
      backgroundColor: '#f4f4f4',
      borderRadius: '8px',
      margin: '20px 0'
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    heading: {
      fontSize: '24px',
      color: '#333'
    },
    icon: {
      width: '30px',
      height: '30px'
    },
    paymentIcon: {
      width: '500px',
      height: '500px'
    },
    paragraph: {
      fontSize: '16px',
      color: '#333',
      marginTop: '10px'
    },
    list: {
      listStyleType: 'disc',
      paddingLeft: '20px'
    }
  };

  return (
    <div>
      {isLoggedIn ? (
        <>
          <Navbar toggleTheme={toggleTheme}isAbout={true}handleLogout={handleLogout} finalizeCart={finalizeCart} />
          <br />
          <section id="about" style={styles.section}>
            <div style={styles.header}>
              <h2 style={styles.heading}>Engineered By Abhishek Ratnam</h2>
              <a href="https://www.linkedin.com/in/abhishek-ratnam-67b69713b/" target="_blank" rel="noopener noreferrer">
                <img src={LinkedInIcon} alt="LinkedIn Profile" style={styles.icon} />
              </a>
            </div>
            <p style={styles.paragraph}>
              I am an experienced backend engineer with a strong background in developing scalable microservice architectures and implementing advanced logging systems. My expertise includes working with technologies like Kafka, RabbitMQ, and Kubernetes, as well as integrating NLP and GPT-based models for real-time data applications.
            </p>
            <p style={styles.paragraph}>
              My notable projects include:
              <ul style={styles.list}>
                <li>Developed an organization-wide logger system using Kafka and RabbitMQ, enabling detailed monitoring of microservices through an RDBMS.</li>
                <li>Contributed to CRM internal product development, enhancing features such as invoice generation.</li>
                <li>Extensively worked on IMS Foundation, a central information system.</li>
                <li>Assisted in the quote generation project for Bank Of Baroda.</li>
                <li>Developed a stock screener product leveraging real-time market data with NLP and GPT models.</li>
                <li>Led backend development for Policy and Cluster Management dashboards, facilitating enforcement of System and Network Policies on Kubernetes Infrastructure using Client-Go API and Cilium.</li>
              </ul>
            </p>
             <h2 style={styles.heading}>Support Our Journey on Patreon</h2>
                <img src={gPay} alt="Gpay Link" style={styles.paymentIcon} />
                
              <h3>Your Support Can Propel This Site to Connect with Talents Worldwide!</h3>
          </section>
          
        </>
      ) : (
        <Link to="/login">Please login via this link</Link>
      )}
    </div>
  );
};

export default About;
